import React, { useState } from 'react'
import { Button, Card, Modal, Popconfirm, Row, Tooltip, notification } from 'antd'
import { CopyOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom'
import { QRCode } from 'react-qrcode-logo'
// import useHttp from '../../../hooks/use-http';
import CONSTANTS from '../../../util/constant/CONSTANTS';
import Heading from '../../../component/common/Heading';
import CRUDComponent from '../../../component/common/CRUD-Component';
import { role } from '../../../util/Route';

const FeederData = () => {
    // const [refresh, setRefresh] = useState(false)
    const [qrData, setQrData] = useState(null)
    // const api = useHttp()
    const navigate = useNavigate();
    // const addFeederHandler = () => {


    //     api.sendRequest(CONSTANTS.API.Feeder.add, () => {
    //         setRefresh(prev => !prev)
    //     }, {}, 'Feeder Added Successfully!!!')


    // }

    const copyHandler = (id, type = "uniqueId") => {
        try {
            window.navigator.clipboard.writeText(id)
            notification.success({ message: `${type === "uniqueId" ? "Unique Id" : "Feeder DID"} Copied` })

        } catch (error) {
            notification.error({ message: 'Something went wrong' })
        }
    }

    const downloadQRCode = async () => {
        const canvas = document.getElementById('myqrcode')?.querySelector('canvas');

        if (canvas) {
            // Wait for the QR code to render
            await new Promise(resolve => setTimeout(resolve, 500)); // Adjust the delay as needed

            const url = canvas.toDataURL();
            const a = document.createElement('a');
            a.download = 'QRCode.png';
            a.href = url;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    };



    return (
        <>

            <div>
                {/* <Popconfirm className='mt-5' title="Sure to Add New Feeder?" onConfirm={addFeederHandler}>
                    <Button type="primary">
                        Add  Feeder
                    </Button>
                    <Button type="primary">{value?.name}</Button>
                </Popconfirm> */}
                <Card className="my-5">
                    <Heading>Feeder List</Heading>
                    <Row>
                        <CRUDComponent

                            GET={{
                                API: CONSTANTS.API.Feeder.getAll,
                                DataModifier: (res, API, Setrefresh) => {
                                    // console.log(res, "GET ALL ABCD");
                                    return res?.map(data => {
                                        return {
                                            ...data,
                                            firmwareVersion: data?.firmwareVersion,
                                            no: `F${data?.id.toString().padStart(7, "0")}`,
                                            uniqueIdD: data?.uniqueId ? <div> {data?.uniqueId} <Tooltip title="Copy Unique Id"> <CopyOutlined onClick={() => {
                                                copyHandler(data?.uniqueId)
                                            }} /></Tooltip> </div> : '-',
                                            DID_D: data?.DID ? <div> {data?.DID} <Tooltip title="Copy Unique Id"> <CopyOutlined onClick={() => {
                                                copyHandler(data?.DID, "feeder")
                                            }} /></Tooltip> </div> : '-',
                                            isActive: data?.isActive ? "Yes" : "No",
                                            view: {
                                                id: data?.id,
                                                onClick: () => {
                                                    navigate(`/app/feeder/${data?.id}`)
                                                },
                                            },
                                            qrcode: {
                                                id: data?.id,
                                                isDisable: !data?.DID,
                                                onClick: () => {
                                                    setQrData({
                                                        feederDID: data?.DID,
                                                    })
                                                }
                                            },



                                        }
                                    })
                                },
                                column: role === 'Admin' ? CONSTANTS.TABLE.ADMIN_FEEDER_LIST : CONSTANTS.TABLE.FEEDER_LIST,

                            }}


                            CREATE={{
                                API: CONSTANTS.API.Feeder.add,
                                message: "Created Feeder successfully",
                                modaltitle: "Add Feeder",
                                modalFields: CONSTANTS.FORM_FIELD.FEEDER_MODAL,
                                payloadModifier: (res) => {
                                    return {
                                        ...res,
                                        firmwareVersion: res?.firmwareVersion?.toString(),
                                    }
                                },
                            }}
                            UPDATE={{
                                API: CONSTANTS.API.Feeder.update,
                                message: "Update Feeder successfully",
                                modaltitle: "Update Feeder",
                                modalFields: CONSTANTS.FORM_FIELD.EDIT_FEEDER_MODAL,
                                payloadModifier: (res) => {
                                    return {
                                        ...res,
                                        firmwareVersion: res?.firmwareVersion?.toString(),
                                    }
                                },
                            }}
                            DELETE={{
                                API: CONSTANTS.API.Feeder.delete,
                                message: "Deleted Feeder Successfully",
                            }}
                            isSearch={true}
                            QRdownload

                        />
                    </Row>
                </Card>
                <Modal
                    open={qrData !== null}
                    title={<p className="form-modal-head mb25">Generate QR Code</p>}
                    okText="Submit"
                    // width={1000}
                    centered
                    cancelButtonProps={{ style: { display: "none" } }}
                    okButtonProps={{ style: { display: "none" } }}
                    className="form-modal-title"
                    onCancel={() => setQrData(null)}
                    onOk={() => setQrData(null)}
                >
                    <div className='flex flex-col justify-center items-center ' >
                        <div id="myqrcode">
                            <QRCode
                                value={JSON.stringify(qrData)}
                                bgColor="#fff"
                                style={{
                                    marginBottom: 16,
                                }}
                            />
                        </div>
                        <Button type="primary" onClick={downloadQRCode}>
                            Download
                        </Button>

                    </div>
                </Modal>
            </div>

        </>
    )
}

export default FeederData